module.exports = __webpack_public_path__ + "static/assets/f2eec5f56533a92c34e826f2d24690e4.png";